import axios from 'axios';
import React, { useEffect, useState } from 'react';
import SaveModal from '../modal/saveModal';

function EstimateConfirm() {
    const [modalAction, setModalAction] = useState(null);
    const [modalContent, setModalContent] = useState(null);
    const [saveStatus, setSaveStatus] = useState(true);

    const isLocal = window.location.hostname != 'wpal.philippineair.co.kr';
    const domain = isLocal ? process.env.REACT_APP_LOCAL_API_URL : process.env.REACT_APP_PRODUCTION_API_URL;
    const searchParams = new URLSearchParams(window.location.search);
    const key = searchParams.get('key');

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (!key) {
                    const error = new Error('404 NOT FOUND');
                    error.response = { data: { message: '404 NOT FOUND' } };
                    throw error;
                }
    
                await axios.patch(`${domain}/api/v2/group/confirm`, { key })

                setModalContent('처리되었습니다.');
            } catch (error) {
                setModalContent(`${error.response.data.message}`);
            } finally {
                setModalAction(() => () => {
                    window.location.href = '/';
                });
                setSaveStatus(false);
            }
        }

        fetchData();
    }, [])

    return (
        <div>
            <SaveModal content={modalContent} SaveBtn={saveStatus} onClose={modalAction} />
        </div>
    );
}

export default EstimateConfirm;